import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from 'bh-mod/layouts/App'
import Splash from '@/layouts/Splash'
import AuthLayout from 'bh-mod/layouts/Auth'
import store from '@/store'
import { VueAppMiddleware } from 'bh-mod'

Vue.use(Router)

const router = new Router({
	base: process.env.BASE_URL,
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	routes: [
		{
			path: '/',
			redirect: '/v3',
			component: AppLayout,
			meta: { instanceRequired: true, auth: true, hidden: true, },
			children: [
				{
					path: '/',
					meta: {
						title: 'Contract Templates',
						leftNav: true,
						crumbName: 'Contract Templates',
						sidebar: true,
						dataRequired: true,
						listView: true,
					},
					component: () =>
						import('./views/templates'),
				},
				{
					path: '/template',
					meta: {
						title: 'New Templates',
						leftNav: true,
						sidebar: true,
						crumbName: 'Add Contract Templates',
						sidebarCollapsed: true,
						dataRequired: true
					},
					component: () =>
						import('./views/templates/setup'),
				},
				{
					path: '/template/:id',
					meta: {
						title: 'Contract Templates',
						leftNav: true,
						crumbName: 'Edit Contract Template',
						sidebar: true,
						edit: true,
						sidebarCollapsed: true,
						dataRequired: true
					},
					component: () =>
						import('./views/templates/setup'),
				},
				{
					path: "/tasks-dashboard",
					meta: {
						title: "Tasks Dashboard",
						sidebar: true,
						dataRequired: true
					},
					component: () => import("bh-mod/components/layout/TopBar/TasksDashboard/allTasks.vue"),
				},
				{
					path: "/notifications",
					meta: {
						title: "All Notifications",
						leftNav: true,
						sidebar: true,
						edit: true,
						sidebarCollapsed: true,
						dataRequired: true
					},
					component: () => import('bh-mod/components/layout/TopBar/Notifications/notifications.vue'),
				},
			],
		},
		{
			path: '/template/:id/prepare',
			component: () => import('./views/templates/contract'),
			meta: { title: 'Template Builder', instanceRequired: true, auth: true, hidden: true, dataRequired: true },
		},
		{
			path: '/setup',
			component: Splash,
			meta: { hidden: true, splash: true },
			children: [{
				path: '/setup',
				meta: {
					title: 'Setup Contract Templates',
					splashScreen: true
				},
				component: () =>
					import('./views/setup'),

			}]
		},
		{
			path: '/404',
			component: Splash,
			children: [
				{
					path: '/404',
					meta: {
						title: 'Error 404',
					},
					component: () => import('bh-mod/components/common/404.vue'),
				}
			]
		},
		{
			path: '/unauthorized',
			component: AuthLayout,
			children: [
				{
					path: '/unauthorized',
					meta: {
						title: 'Unauthorized',
						unauthorized: true
					},
					component: () => import('bh-mod/components/common/unauthorized.vue'),
				}
			]
		},
		// Other routes...
		{
			// Catch-all route: This will match any invalid route
			path: '*',
			redirect: '/404'
		}
	],
})

let hiveRequested = false;
router.beforeEach(async (to, from, next) => {
	let dataRequired = to.matched.some(record => record.meta.dataRequired)
	let splashScreen = to.matched.some(record => record.meta.splashScreen)
	let unauthorized = to.matched.some(record => record.meta.unauthorized)
	let error = false

	if (!hiveRequested) {
		let response = await VueAppMiddleware(to, store, 'contracts')
		error = response.parsed
		hiveRequested = true;
	}

	if (error) {
		if (error === 'User does not have required permission!') {
			return next('/unauthorized')
		}
		return console.error('ERROR', error)
	} else {
		if (unauthorized) {
			return next();
		}
		const seenIntro = store.state.appData.allSettings?.userApp?.options?.seenIntro
		const templates = Object.keys(store.state.appData.templates).length
		const getStarted = store.state.appData.getStarted

		if (splashScreen && (templates || seenIntro)) {
			return next('/')
		}

		if (dataRequired && !templates && !getStarted && !seenIntro) {
			return next('/setup')
		}
	}

	store.commit('PAGE_BUTTONS', [])

	if (to.meta.crumbName) {
		store.commit('CLEAR_CRUMBS')
	}

	store.commit('LOAD', false)
	next()
})


export default router
